/* ============
 * Mutations for the Management protocol template module
 * ============
 *
 * The mutations that are available on the
 * Management protocol template module.
 */
import types from './mutation-types';

export default {
  [types.GET_MANAGEMENT_PROTOCOL_TEMPLATE](state) {
    state.loading = true;
  },
  [types.GET_MANAGEMENT_PROTOCOL_TEMPLATE_SUCCESS](state, response) {
    state.loading = false;
    state.managementProtocolTemplate = response;
  },
  [types.GET_MANAGEMENT_PROTOCOL_TEMPLATE_FAIL](state, error) {
    state.loading = false;
    state.error = error;
    state.managementProtocolTemplate = {};
  },

  [types.GET_PROTOCOL_LIST](state) {
    state.loading = true;
  },
  [types.GET_PROTOCOL_LIST_SUCCESS](state, response) {
    state.loading = false;
    state.protocolList = response;
  },
  [types.GET_PROTOCOL_LIST_FAIL](state, error) {
    state.loading = false;
    state.error = error;
    state.protocolList = [];
  }

};
